export default __webpack_public_path__ + "images/S5.71a3585.png";